import { useEffect } from 'react';

type UsePaymentFormStartTrackingOptions = {
  editing: boolean;
  handleFormStart: () => void;
  containerId?: string;
};

const usePaymentFormStartTracking = ({
  editing,
  handleFormStart,
  containerId,
}: UsePaymentFormStartTrackingOptions) => {
  useEffect(() => {
    if (editing || !containerId) {
      return undefined;
    }

    const container = document.getElementById(containerId);
    if (!container) {
      return undefined;
    }

    container.addEventListener('focusin', handleFormStart);
    container.addEventListener('click', handleFormStart);

    return () => {
      container.removeEventListener('focusin', handleFormStart);
      container.removeEventListener('click', handleFormStart);
    };
  }, [containerId, editing, handleFormStart]);
};

export default usePaymentFormStartTracking;
